import useMobile from "./useMobile"
import { useMissionsQuery } from "../networking/missions/queries"
import useCareTeam from "../pages/care/useCareTeam"
import { MissionStatus } from "../types"

const useActionButtonPosition = () => {
  const isMobile = useMobile()
  const { data: missions } = useMissionsQuery()
  const { firstTherapist } = useCareTeam()

  const mission = missions?.find(
    (mission) => mission.status.status === MissionStatus.INCOMPLETE
  )

  const defaultPosition = 40
  const mobileNavbarHeight = 40
  const mobileMissionHeight = 56

  let position = defaultPosition
  if (isMobile) position += mobileNavbarHeight
  if (isMobile && mission && !firstTherapist) position += mobileMissionHeight

  return `${position}px`
}

export default useActionButtonPosition
